// src/App.js
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./hooks/useAuth";
import Navbar from "./components/Navbar";
import HomePage    from "./pages/HomePage";
import AwakenPage  from "./pages/AwakenPage";
import ProfilePage from "./pages/ProfilePage";
import AuthPage    from "./pages/AuthPage";
import LorePage    from "./pages/LorePage";
import AboutPage   from "./pages/AboutPage";
import ShopPage    from "./pages/ShopPage";
import CoachPage   from "./pages/CoachPage";
import "./index.css";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/"        element={<HomePage />} />
          <Route path="/awaken"  element={<AwakenPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/auth"    element={<AuthPage />} />
          <Route path="/lore"    element={<LorePage />} />
          <Route path="/about"   element={<AboutPage />} />
          <Route path="/shop"    element={<ShopPage />} />
          <Route path="/coach"   element={<CoachPage />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
